import { Component, Inject, NgModule, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IFirmLicensePerson } from 'app/models/firm/firm-license-person';
import { FirmService } from 'app/services/firm/firm.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-staff-add-edit',
  templateUrl: './staff-add-edit.component.html',
  styleUrls: ['./staff-add-edit.component.scss']
})
export class StaffAddEditComponent implements OnInit {
  buttonText: string = "";
  loading: boolean = false;
  processing: boolean = false;  
  postErrorMessages: string = "";  
  DisciplineList:string[] = ['Risk Assessor', 'Supervisor', 'Worker', 'Project Designer','Inspector']
  objectKeys = Object.keys;
  formFields = {};

  lbpaFormFields = {
    //certificateId:{name: 'Certificate Number', type: 'string'},
    firstName:{name: 'First Name', type: 'string'},
    lastName:{name: 'Last Name', type: 'string'},
    discipline:{name: 'Certificate Type', type: 'option', data: this.DisciplineList},
    firmIsPaying:{name: 'Cover Fee', type: 'boolean'}
  }

  rrpFormFields = {
    //certificateId:{name: 'Certificate Number', type: 'string'},
    firstName:{name: 'First Name', type: 'string'},
    lastName:{name: 'Last Name', type: 'string'},
    atp:{name: 'Training Provider', type: 'string'},
    trainingDate:{name: 'Training Date', type: 'date'}    
  }

  individual: IFirmLicensePerson = {
    id: 0,
    licenseId: 0,
    license: null,
    person: null,
    firstName: '',
    lastName: '',
    certificateId: '',
    discipline: '',
    atp: null,
    trainingDate: null,
    firmIsPaying: false,
  }
  licenseType: string = "";
  individualForm: FormGroup = null;

  constructor( 
    public firmService: FirmService,     
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: {individualData: IFirmLicensePerson, licenseType: string},
    private dialogRef: MatDialogRef<StaffAddEditComponent>) {
    this.loading = true;
    this.individual = this.data ? this.data.individualData : this.individual;
    this.licenseType = this.data.licenseType;
    this.loadfirm();
  }

  ngOnInit(): void { 
    // ngOnInit
  }

  loadfirm() {
    this.loading = true;    
    if (this.individual?.id > 0) {
      this.buttonText = "Update Individual";      
    }
    else {
      this.buttonText = "Add Individual";            
    }
    this.setFormValues();
    this.loading = false;
  }

  onSubmit() {
    if (!this.individualForm.valid) {
      this.postErrorMessages = "Individual Name is required";
      this.toastr.error("Please fix validation errors");
      return;
    }
    
    this.getFormValues();    
    this.firmService.saveFirmLicensePerson(this.individual).subscribe(
      result => {
        this.dialogRef.close();    
      },
      error => {
        
      }
    )
  }

  getFormValues(){
    for (const controlName in this.individual) {
      if (this.individualForm.controls.hasOwnProperty(controlName)) {
        this.individual[controlName] = this.individualForm.controls[controlName].value;        
      } 
    }  
  }

  setFormValues() {
    this.individualForm = new FormGroup({});
    this.formFields = this.licenseType == 'lbpa' ? this.lbpaFormFields : this.rrpFormFields;

    for (const key in this.formFields) {          
      this.individualForm.addControl(key, new FormControl('', Validators.required));      
    }

    for (const controlName in this.individual) {
      if (this.individualForm.controls.hasOwnProperty(controlName)) {
        this.individualForm.controls[controlName].setValue(this.individual[controlName]);
      } 
    } 
  }
}